import * as tslib_1 from "tslib";
import { QuerifyService } from '@core/services/querify.service';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { Mutations } from './mutations';
import { Queries } from './queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./mutations";
import * as i3 from "./queries";
import * as i4 from "../../services/querify.service";
var UsersApi = /** @class */ (function () {
    function UsersApi(apollo, mutations, queries, querify) {
        this.apollo = apollo;
        this.mutations = mutations;
        this.queries = queries;
        this.querify = querify;
    }
    UsersApi.prototype.me = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: this.queries.me(),
                    })
                        .toPromise()
                        .then(function (response) { return response.data['me']; })];
            });
        });
    };
    UsersApi.prototype.meWithAccessToken = function (accessToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: this.queries.me(),
                        context: {
                            headers: {
                                Authorization: "Bearer " + accessToken
                            }
                        }
                    })
                        .toPromise()
                        .then(function (response) { return response.data; })];
            });
        });
    };
    UsersApi.prototype.save = function (user) {
        return this.apollo.mutate({
            mutation: this.mutations.createUser(),
            variables: {
                input: user
            }
        });
    };
    UsersApi.prototype.update = function (id, user) {
        return this.apollo.mutate({
            mutation: this.mutations.updateUser(),
            variables: {
                id: id,
                input: user
            }
        });
    };
    UsersApi.prototype.archiveUser = function (id) {
        return this.apollo.mutate({
            mutation: this.mutations.archiveUser(),
            variables: {
                id: id
            }
        });
    };
    UsersApi.prototype.unarchiveUser = function (id) {
        return this.apollo.mutate({
            mutation: this.mutations.unarchiveUser(),
            variables: {
                id: id
            }
        });
    };
    UsersApi.prototype.search = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.getUsers(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['users'];
        }));
    };
    UsersApi.prototype.searchOne = function (id) {
        return this.apollo
            .query({
            query: this.queries.getUser(),
            variables: { id: id }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['user'];
        }));
    };
    UsersApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UsersApi_Factory() { return new UsersApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Mutations), i0.ɵɵinject(i3.Queries), i0.ɵɵinject(i4.QuerifyService)); }, token: UsersApi, providedIn: "root" });
    return UsersApi;
}());
export { UsersApi };
